module.exports = __webpack_public_path__ + "static/media/HalifaxBannerTab.f8cfd106.jpeg";